import React, { Component } from 'react'
import PropTypes from 'prop-types'

import SuggestionRemove from 'component/suggestion/SuggestionRemove'

class SuggestionTable extends Component {
  constructor(props) {
    super(props)

    this.state = {
      suggestionsSelected: [],
      suggestionsSelectedIndex: [],
      lastSuggestionSelected: {},
      totalSelected: 0,
    }

    this.clearEmptySlots = this.clearEmptySlots.bind(this)
    this.shouldRenderButtons = this.shouldRenderButtons.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.renderRows = this.renderRows.bind(this)
    this.renderNewtag = this.renderNewtag.bind(this)
    this.renderStatusTag = this.renderStatusTag.bind(this)
  }

  clearEmptySlots() {
    const { suggestionsSelected } = this.state

    const lsMissionMenus = []

    if (suggestionsSelected) {
      for (let i = 0; i < suggestionsSelected.length; i++) {
        if (suggestionsSelected[i]) {
          lsMissionMenus.push(suggestionsSelected[i])
        }
      }
    }

    return lsMissionMenus
  }

  shouldRenderButtons() {
    const { setRenderButtons } = this.props

    const lsMissionMenus = this.clearEmptySlots()
    const totalSelected = lsMissionMenus.length

    if (totalSelected > 0) {
      setRenderButtons(true)
    } else {
      setRenderButtons(false)
    }

    this.setState({ totalSelected })
  }

  renderNewtag(suggestion) {
    const { translate } = this.props

    if (suggestion.inShow !== 1) {
      return (
        <span className='badge badge-warning color-default-dark margin-right'>
          {translate('suggestions.new')}
        </span>
      )
    }
    return ''
  }

  handleClick(index) {
    const { getSuggestion } = this.props

    getSuggestion(index)
  }

  renderStatusTag(suggestion, index) {
    const { translate } = this.props

    if (suggestion.dsAnswer != null) {
      return (
        <button
          className='button button-default button-sm'
          onClick={() => {
            this.handleClick(index)
          }}
        >
          {translate('suggestions.view')}
        </button>
      )
    }
    return (
      <button
        className='button button-primary button-sm'
        onClick={() => {
          this.handleClick(index)
        }}
      >
        {translate('suggestions.answer')}
      </button>
    )
  }

  renderRows(suggestion, index) {
    const rowClass = suggestion.inShow === 1 ? '' : ' strong'
    return (
      <tr key={index} className='margin-right'>
        <td className={`align-left overflow-hidden-column${rowClass}`}>
          {suggestion.cdLdap}
          {suggestion.dsUser ? ` - ${suggestion.dsUser}` : ''}
        </td>
        <td className={`align-left overflow-hidden-column${rowClass}`}>
          {suggestion.dsSuggestion}
        </td>
        <td className='align-right overflow-hidden-column margin-right'>
          {this.renderNewtag(suggestion)}
          {this.renderStatusTag(suggestion, index)}
          <a
            role='button'
            className='margin-left'
            onClick={() => this.toggleRemove(suggestion)}
          >
            <i className='glyph glyph-grey glyph-trash-can icon-size' />
          </a>
        </td>
      </tr>
    )
  }

  renderRemoveSuggestion = () => {
    const { suggestion, suggestionModal } = this.state
    const { translate, handleDeleteSuggestion } = this.props

    /* istanbul ignore else */
    if (!suggestionModal) {
      return
    }

    const temporarySuggestion = { idSuggestion: suggestion.idSuggestion }

    return (
      <SuggestionRemove
        onSubmit={() => {
          handleDeleteSuggestion(temporarySuggestion)
          this.toggleRemove({})
        }}
        translate={translate}
        closeModal={() => this.toggleRemove({})}
        suggestion={suggestion}
      />
    )
  }

  toggleRemove = (item) => {
    this.setState({
      suggestionModal: !this.state.suggestionModal,
      suggestion: item,
    })
  }

  render() {
    const { suggestions, translate } = this.props

    return (
      <div className='SuggestionTable'>
        <table className='table table-zebra margin-top-double table-layout-fixed'>
          <thead>
            <tr>
              <th className='align-left hidden-column overflow-hidden-column'>
                {translate('suggestion.ldap')}
              </th>
              <th className='align-left overflow-hidden-column'>
                {translate('suggestion.message')}
              </th>
              <th className='align-left overflow-hidden-column' />
            </tr>
          </thead>
          <tbody>{suggestions.map(this.renderRows)}</tbody>
        </table>
        {this.renderRemoveSuggestion()}
      </div>
    )
  }
}

SuggestionTable.propTypes = {
  suggestions: PropTypes.array.isRequired,
  translate: PropTypes.func.isRequired,
  setRenderButtons: PropTypes.func.isRequired,
  getSuggestion: PropTypes.func.isRequired,
  handleDeleteSuggestion: PropTypes.func.isRequired,
}

export default SuggestionTable
